(function () {
  var KEY = 'rfqqq_quote_list';
  var dataEl = document.getElementById('rfqqq-product-data');
  if (!dataEl) return;
  var P = JSON.parse(dataEl.textContent);

  function money(v) { return '$' + Number(v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function readList() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function writeList(l) { localStorage.setItem(KEY, JSON.stringify(l)); updateBadges(); }
  function updateBadges() {
    var n = readList().length;
    document.querySelectorAll('[data-rfqqq-quote-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
  }
  updateBadges();

  var copyBtn = document.querySelector('[data-rfqqq-copy-btn]');
  if (copyBtn && navigator.clipboard) {
    copyBtn.addEventListener('click', function () {
      var v = document.querySelector('[data-rfqqq-copy]').getAttribute('data-rfqqq-copy');
      navigator.clipboard.writeText(v).then(function () { copyBtn.textContent = 'Copied'; setTimeout(function () { copyBtn.textContent = 'Copy'; }, 1500); });
    });
  }

  var buyForm = document.querySelector('[data-rfqqq-buy]');
  if (buyForm) {
    buyForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var msg = document.querySelector('[data-rfqqq-buy-msg]');
      var fd = new FormData(buyForm);
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (r) {
          if (r.status) { msg.textContent = r.description || 'Could not add to cart.'; return; }
          return fetch('/cart.js').then(function (c) { return c.json(); }).then(function (c) {
            msg.innerHTML = 'Added. <a href="/cart">Cart has ' + c.item_count + ' item' + (c.item_count === 1 ? '' : 's') + '</a>';
            document.querySelectorAll('.cart-count-bubble span[aria-hidden]').forEach(function (b) { b.textContent = c.item_count; });
          });
        })
        .catch(function () { msg.textContent = 'Could not add to cart.'; });
    });
  }

  var quoteBtn = document.querySelector('[data-rfqqq-add-quote]');
  if (quoteBtn) {
    quoteBtn.addEventListener('click', function () {
      var msg = document.querySelector('[data-rfqqq-quote-msg]');
      var qtyEl = document.querySelector('.rfqqq-qty');
      var qty = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
      var list = readList();
      var existing = list.filter(function (x) { return x.variantId === P.variantId; })[0];
      if (existing) { existing.qty = qty; } else {
        list.push({ handle: P.handle, title: P.title, mpn: P.mpn, url: P.url, variantId: P.variantId, ourPrice: P.price, qty: qty, offers: P.offers || [], added: Date.now() });
      }
      writeList(list);
      msg.innerHTML = (existing ? 'Updated. ' : 'Added. ') + '<a href="/pages/quote-list">Quote list has ' + list.length + ' line' + (list.length === 1 ? '' : 's') + '</a>';
    });
  }

  function renderStats() {
    var h = P.history; if (!h || !h.months) return;
    var box = document.querySelector('[data-rfqqq-stats]'); if (!box) return;
    var all = []; Object.keys(h.series).forEach(function (k) { h.series[k].forEach(function (v) { if (v != null) all.push(v); }); });
    var lastIdx = h.months.length - 1, todays = [];
    Object.keys(h.series).forEach(function (k) { var v = h.series[k][lastIdx]; if (v != null) todays.push(v); });
    var lo = Math.min.apply(null, all);
    var spread = todays.length > 1 ? (Math.max.apply(null, todays) - Math.min.apply(null, todays)) / Math.min.apply(null, todays) * 100 : 0;
    var us = P.offers.filter(function (o) { return o.is_us; })[0];
    var usKey = us ? us.supplier : Object.keys(h.series)[0];
    var s = h.series[usKey] || h.series[Object.keys(h.series)[0]];
    var trend = s.length > 1 ? (s[s.length - 1] < s[s.length - 2] ? 'Falling' : s[s.length - 1] > s[s.length - 2] ? 'Rising' : 'Flat') : '—';
    box.querySelector('[data-stat=low]').textContent = money(lo);
    box.querySelector('[data-stat=spread]').textContent = spread.toFixed(1) + '%';
    var t = box.querySelector('[data-stat=trend]'); t.textContent = trend; t.className = trend === 'Falling' ? 'rfqqq-ok' : trend === 'Rising' ? 'rfqqq-warn' : '';
  }

  function renderChart() {
    var h = P.history, c = document.getElementById('rfqqq-history-chart');
    if (!h || !h.months || !c || !window.Chart) return;
    var palette = ['#378ADD', '#1D9E75', '#D85A30', '#888780', '#7F77DD', '#EF9F27'];
    var nameFor = {}; (P.offers || []).forEach(function (o) { nameFor[o.supplier] = o.name; });
    var keys = Object.keys(h.series);
    var usKey = (P.offers.filter(function (o) { return o.is_us; })[0] || {}).supplier;
    var ds = keys.map(function (k, i) {
      return { label: nameFor[k] || k, data: h.series[k], borderColor: palette[i % palette.length], backgroundColor: palette[i % palette.length], borderWidth: k === usKey ? 2.25 : 1.25, pointRadius: 0, tension: 0.3 };
    });
    var labels = h.months.map(function (m) { var d = new Date(m + '-01T00:00:00'); return d.toLocaleString('en-US', { month: 'short' }) + (d.getMonth() === 0 ? ' ' + d.getFullYear() : ''); });
    new Chart(c, { type: 'line', data: { labels: labels, datasets: ds }, options: {
      responsive: true, maintainAspectRatio: false, interaction: { mode: 'index', intersect: false },
      plugins: { legend: { position: 'bottom', labels: { boxWidth: 8, boxHeight: 8, usePointStyle: true, pointStyle: 'circle', font: { size: 11 } } },
        tooltip: { callbacks: { label: function (x) { return x.dataset.label + ': ' + money(x.parsed.y); } } } },
      scales: { x: { grid: { display: false }, ticks: { font: { size: 11 }, maxTicksLimit: 8 } },
        y: { grid: { color: 'rgba(128,128,128,0.16)' }, ticks: { font: { size: 11 }, callback: function (v) { return '$' + v; } } } }
    } });
  }

  renderStats();
  if (window.Chart) renderChart(); else window.addEventListener('load', renderChart);
})();
